import * as Types from '../../graphqlBase.generated';

import { TypedDocumentString } from "~/gql/graphqlBase.generated";
import { baseApiWithGraphql } from '~/services/baseApi';
import type { GraphqlEndpointBuilder } from '~/services/baseApi';
export type CreateConsolidationPreviewMutationVariables = Types.Exact<{
  input: Types.CreateConsolidationPreviewInput;
}>;


export type CreateConsolidationPreviewMutation = { __typename?: 'Mutation', createConsolidationPreview: { __typename?: 'CreateConsolidationPreviewPayload', success: boolean, preview?: { __typename?: 'ConsolidationPreview', id: string, createdAt: Types.TDateISO, createdBy: string, expiresAt: Types.TDateISO, productionPlanIds: Array<string>, scenario: Types.ConsolidationScenario, rulesVersion: number, computeMilliseconds: number, summary: { __typename?: 'ConsolidationPreviewSummary', lotsBefore: number, lotsAfter: number, quantityBefore: number, quantityAfter: number, smallLotUnder: number, smallLotsBefore: number, smallLotsAfter: number, runCount: number, lotsKeptAtPlannerSite: number, lotsWithoutRecipe: number, lotsBoundToOrder: number, pinnedLots: number, windowEdgeNoteCount: number, runStatusCounts: Array<{ __typename?: 'ConsolidationRunStatusCount', status: Types.ConsolidationRunStatus, count: number }>, bridge: Array<{ __typename?: 'ConsolidationBridgeLine', kind: Types.ConsolidationBridgeKind, quantity: number, lots: number }>, steps: Array<{ __typename?: 'ConsolidationStepImpact', step: Types.ConsolidationStep, change: Types.ConsolidationLotChange, lots: number, quantity: number }> }, runs: Array<{ __typename?: 'ConsolidationPreviewRun', productionPlanId: string, siteLocationId: string, productionCategoryId: string, genera: Array<string>, startWeek: Types.TDateISO, quantity: number, containers?: number | null, minimumEaches?: number | null, slowWeek: boolean, status: Types.ConsolidationRunStatus, mergedStartWeeks: Array<Types.TDateISO> }>, windowEdgeNotes: Array<{ __typename?: 'ConsolidationWindowEdgeNote', customerGroupId: string, productionCategoryId: string, genus?: string | null, edge: Types.ConsolidationWindowEdge, readyWeek: Types.TDateISO, quantity: number, neighborReadyWeek?: Types.TDateISO | null, neighborQuantity?: number | null }>, plannerChanges: Array<{ __typename?: 'ConsolidationPlannerChangeGroup', kind: Types.ConsolidationPlannerChangeKind, lots: number, quantity: number, firstChangedAt?: Types.TDateISO | null, lastChangedAt?: Types.TDateISO | null, kept: boolean }>, space: Array<{ __typename?: 'ConsolidationSpaceImpact', siteLocationId: string, spaceTypeId: string, approximate: boolean, before: { __typename?: 'ConsolidationSpacePeak', peakPercent: number, peakWeek?: Types.TDateISO | null, weeksOver: number }, after: { __typename?: 'ConsolidationSpacePeak', peakPercent: number, peakWeek?: Types.TDateISO | null, weeksOver: number }, weeks: Array<{ __typename?: 'ConsolidationSpaceWeek', week: Types.TDateISO, before: number, after: number, capacity: number }> }> } | null, errors?: Array<{ __typename?: 'ValidationError', code?: string | null, message: string }> | null } };

export type SetConsolidationLotPinsMutationVariables = Types.Exact<{
  input: Types.SetConsolidationLotPinsInput;
}>;


export type SetConsolidationLotPinsMutation = { __typename?: 'Mutation', setConsolidationLotPins: { __typename?: 'SetConsolidationLotPinsPayload', pinnedProductionLotIds: Array<string>, success: boolean, errors?: Array<{ __typename?: 'ValidationError', code?: string | null, message: string }> | null } };

export type ApplyConsolidationPreviewMutationVariables = Types.Exact<{
  input: Types.ApplyConsolidationPreviewInput;
}>;


export type ApplyConsolidationPreviewMutation = { __typename?: 'Mutation', applyConsolidationPreview: { __typename?: 'ConsolidationApplicationPayload', success: boolean, application?: { __typename?: 'ConsolidationApplication', id: string, previewId: string, productionPlanIds: Array<string>, rulesVersion: number, scenario: Types.ConsolidationScenario, status: Types.ConsolidationApplicationStatus, appliedAt: Types.TDateISO, appliedBy: string, finishedAt?: Types.TDateISO | null, undoneAt?: Types.TDateISO | null, undoneBy?: string | null, lotsTotal: number, lotsDone: number, lotsCreated: number, lotsChanged: number, lotsAbsorbed: number, lotsRemoved: number, lotsMovedToPlan: number, quantityBefore: number, quantityAfter: number, quantityRemoved: number, error?: string | null } | null, errors?: Array<{ __typename?: 'ValidationError', code?: string | null, message: string }> | null } };

export type UndoConsolidationApplicationMutationVariables = Types.Exact<{
  input: Types.UndoConsolidationApplicationInput;
}>;


export type UndoConsolidationApplicationMutation = { __typename?: 'Mutation', undoConsolidationApplication: { __typename?: 'ConsolidationApplicationPayload', success: boolean, application?: { __typename?: 'ConsolidationApplication', id: string, previewId: string, productionPlanIds: Array<string>, rulesVersion: number, scenario: Types.ConsolidationScenario, status: Types.ConsolidationApplicationStatus, appliedAt: Types.TDateISO, appliedBy: string, finishedAt?: Types.TDateISO | null, undoneAt?: Types.TDateISO | null, undoneBy?: string | null, lotsTotal: number, lotsDone: number, lotsCreated: number, lotsChanged: number, lotsAbsorbed: number, lotsRemoved: number, lotsMovedToPlan: number, quantityBefore: number, quantityAfter: number, quantityRemoved: number, error?: string | null } | null, errors?: Array<{ __typename?: 'ValidationError', code?: string | null, message: string }> | null } };


export const CreateConsolidationPreviewDocument = new TypedDocumentString(`
    mutation CreateConsolidationPreview($input: CreateConsolidationPreviewInput!) {
  createConsolidationPreview(input: $input) {
    preview {
      ...ConsolidationPreviewFields
    }
    errors {
      code
      message
    }
    success
  }
}
    fragment ConsolidationPreviewFields on ConsolidationPreview {
  id
  createdAt
  createdBy
  expiresAt
  productionPlanIds
  scenario
  rulesVersion
  computeMilliseconds
  summary {
    lotsBefore
    lotsAfter
    quantityBefore
    quantityAfter
    smallLotUnder
    smallLotsBefore
    smallLotsAfter
    runCount
    runStatusCounts {
      status
      count
    }
    lotsKeptAtPlannerSite
    lotsWithoutRecipe
    lotsBoundToOrder
    pinnedLots
    windowEdgeNoteCount
    bridge {
      kind
      quantity
      lots
    }
    steps {
      step
      change
      lots
      quantity
    }
  }
  runs {
    productionPlanId
    siteLocationId
    productionCategoryId
    genera
    startWeek
    quantity
    containers
    minimumEaches
    slowWeek
    status
    mergedStartWeeks
  }
  windowEdgeNotes {
    customerGroupId
    productionCategoryId
    genus
    edge
    readyWeek
    quantity
    neighborReadyWeek
    neighborQuantity
  }
  plannerChanges {
    kind
    lots
    quantity
    firstChangedAt
    lastChangedAt
    kept
  }
  space {
    siteLocationId
    spaceTypeId
    approximate
    before {
      peakPercent
      peakWeek
      weeksOver
    }
    after {
      peakPercent
      peakWeek
      weeksOver
    }
    weeks {
      week
      before
      after
      capacity
    }
  }
}`);
export const SetConsolidationLotPinsDocument = new TypedDocumentString(`
    mutation SetConsolidationLotPins($input: SetConsolidationLotPinsInput!) {
  setConsolidationLotPins(input: $input) {
    pinnedProductionLotIds
    errors {
      code
      message
    }
    success
  }
}
    `);
export const ApplyConsolidationPreviewDocument = new TypedDocumentString(`
    mutation ApplyConsolidationPreview($input: ApplyConsolidationPreviewInput!) {
  applyConsolidationPreview(input: $input) {
    application {
      ...ConsolidationApplicationFields
    }
    errors {
      code
      message
    }
    success
  }
}
    fragment ConsolidationApplicationFields on ConsolidationApplication {
  id
  previewId
  productionPlanIds
  rulesVersion
  scenario
  status
  appliedAt
  appliedBy
  finishedAt
  undoneAt
  undoneBy
  lotsTotal
  lotsDone
  lotsCreated
  lotsChanged
  lotsAbsorbed
  lotsRemoved
  lotsMovedToPlan
  quantityBefore
  quantityAfter
  quantityRemoved
  error
}`);
export const UndoConsolidationApplicationDocument = new TypedDocumentString(`
    mutation UndoConsolidationApplication($input: UndoConsolidationApplicationInput!) {
  undoConsolidationApplication(input: $input) {
    application {
      ...ConsolidationApplicationFields
    }
    errors {
      code
      message
    }
    success
  }
}
    fragment ConsolidationApplicationFields on ConsolidationApplication {
  id
  previewId
  productionPlanIds
  rulesVersion
  scenario
  status
  appliedAt
  appliedBy
  finishedAt
  undoneAt
  undoneBy
  lotsTotal
  lotsDone
  lotsCreated
  lotsChanged
  lotsAbsorbed
  lotsRemoved
  lotsMovedToPlan
  quantityBefore
  quantityAfter
  quantityRemoved
  error
}`);
const injectedRtkApiEndpoints = (build: GraphqlEndpointBuilder) => ({
    CreateConsolidationPreview: build.mutation<CreateConsolidationPreviewMutation, CreateConsolidationPreviewMutationVariables>({
      query: (variables) => ({ document: CreateConsolidationPreviewDocument, variables })
    }),
    SetConsolidationLotPins: build.mutation<SetConsolidationLotPinsMutation, SetConsolidationLotPinsMutationVariables>({
      query: (variables) => ({ document: SetConsolidationLotPinsDocument, variables })
    }),
    ApplyConsolidationPreview: build.mutation<ApplyConsolidationPreviewMutation, ApplyConsolidationPreviewMutationVariables>({
      query: (variables) => ({ document: ApplyConsolidationPreviewDocument, variables })
    }),
    UndoConsolidationApplication: build.mutation<UndoConsolidationApplicationMutation, UndoConsolidationApplicationMutationVariables>({
      query: (variables) => ({ document: UndoConsolidationApplicationDocument, variables })
    }),
});

const injectedRtkApi = baseApiWithGraphql.injectEndpoints({ endpoints: injectedRtkApiEndpoints });

export type GeneratedEndpointDefinitions = ReturnType<typeof injectedRtkApiEndpoints>;

export { injectedRtkApi as api };
export const { useCreateConsolidationPreviewMutation, useSetConsolidationLotPinsMutation, useApplyConsolidationPreviewMutation, useUndoConsolidationApplicationMutation } = injectedRtkApi;
